document.addEventListener('DOMContentLoaded', () => {
    let animatedBlocks = [];

    function animationInit() {
        animatedBlocks = Array.from(document.querySelectorAll('.js-animated-block'));

        scrollManager();
        window.addEventListener('scroll', scrollManager);
        window.__scrollManager = scrollManager;
    }

    function offset(el) {
        const rect = el.getBoundingClientRect();
        const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
    }

    function getScrollTop() {
        return window.scrollY || document.documentElement.scrollTop || document.body.scrollTop;
    }

    function scrollManager() {
        const scrollTop = getScrollTop();
        const toAnimate = [];

        animatedBlocks.forEach((block, i) => {
            const position = offset(block).top - scrollTop;
            const trigger = window.innerHeight / 1.4;
            const firstTrigger = window.innerHeight - 100;

            if (position < trigger || (i <= 1 && position < firstTrigger && scrollTop < 100)) {
                if (!block.classList.contains('animated') && !block.classList.contains('in-que')) {
                    toAnimate.push(block);
                }
            }
        });

        toAnimate.forEach((block, i) => {
            let delay = scrollTop > 100 ? i * 10 : i * 300;
            activateBlock(block, delay);
        });
    }

    function activateBlock(block, delay) {
        if (!block.classList.contains('animated')) {
            block.classList.add('in-que');
            setTimeout(() => {
                block.classList.add('animated');
                handleAnimatedBlock(block);
            }, delay);
        }
    }

    function handleAnimatedBlock(block) {
        const blockGroups = block.querySelectorAll('.js-animated-group');
        if (blockGroups.length) {
            blockGroups.forEach(group => handleAnimatedGroup(group));
        } else {
            handleAnimatedGroup(block);
        }
    }

    function handleAnimatedGroup(group) {
        const elements = group.querySelectorAll('.js-animated-element');
        elements.forEach((element, i) => handleAnimatedElement(element, i));
    }

    function handleAnimatedElement(element, index) {
        setTimeout(() => {
            element.classList.remove('prepared');
            evaluateCountUp(element);
            evaluateChart(element);
        }, 120 * index);
    }

    function evaluateCountUp(element) {
        const countUp = element.querySelector('.animate-count-up');
        if (!countUp) return;
        countUpFn(countUp, 750);
    }

    function countUpFn(countUpEl, milliseconds) {
        const countValueEl = countUpEl.querySelector('.count-value');
        let value = Number(countValueEl.dataset.countValue);
        const target = Number(countValueEl.dataset.countTarget);
        const step = target / (milliseconds / 10);
        const interval = Math.ceil(milliseconds / (milliseconds / 10));

        value += step;

        if (value < target) {
            countValueEl.innerHTML = Math.ceil(value);
            countValueEl.dataset.countValue = value;
        } else {
            countValueEl.innerHTML = target;
            showSuffix();
            return;
        }

        function showSuffix() {
            const suffix = countUpEl.querySelector('.suffix');
            if (suffix) suffix.classList.add('shown');
        }

        requestAnimationFrame(() => {
            setTimeout(() => {
                countUpFn(countUpEl, milliseconds);
            }, interval);
        });
    }

    function evaluateChart(element) {
        if (element.classList.contains('js-chart-type-xy') && typeof window.__buildXyChart === 'function') {
            window.__buildXyChart(element);
        } else if (element.classList.contains('js-chart-type-pie') && typeof window.__buildPieChart === 'function') {
            window.__buildPieChart(element);
        }
    }

    animationInit();
});
